export default __webpack_public_path__ + "static/media/rain-night.3d4a68a3.svg";